import { StarsButton, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import RewardsLogo from '@swf/components/StarsRewards/components/RewardsLogo/RewardsLogo';
import useEmbeddedNavigation from '@swf/core/hooks/useEmbeddedNavigation';
import { InfoZone, OptInZone } from '@swf/core/types/Rewards';

import Info from '../../assets/info.svg';

import { TXTCLI_Join_our_free_Stars_Rewards_pr_ELL, TXTCLI_Start } from './Optin.messages.json';
import styles from './Optin.scss';

export interface Props {
  expanded?: boolean;
}

const OptIn: React.FC<React.PropsWithChildren<Props>> = ({ expanded, children }) => {
  const open = useEmbeddedNavigation();
  return (
    <div className={classNames(styles.optIn, { [styles.expanded]: expanded })}>
      {expanded ? (
        <>
          <RewardsLogo inverse />
          <Info onClick={() => open(InfoZone)} />
          <div className={styles.intro}>
            <Translation {...TXTCLI_Join_our_free_Stars_Rewards_pr_ELL} />
          </div>
        </>
      ) : (
        <RewardsLogo />
      )}
      <StarsButton
        className={styles.button}
        variant={expanded ? 'primary' : 'secondary'}
        inverse
        size="small"
        block={expanded}
        onClick={() => open(OptInZone)}
        translation={TXTCLI_Start}
      />
      {children}
    </div>
  );
};

export default OptIn;
